import { Component, OnInit } from '@angular/core';
import { NgToastService } from './ng-toast.service';
import { IToast } from './toast.model';

@Component({
  selector: 'lib-ng-toast',
  templateUrl:'./ng-toast.component.html',
  styleUrls: ['./ng-toast.component.scss'
  ]
})
export class NgToastComponent implements OnInit {

  show: boolean = false;
  toastDetails: any;
  timeoutRef: any;
  constructor(private toastService: NgToastService) {}

  ngOnInit(): void {
    this.toastService.toastDetails$.subscribe((val:IToast) => {
      this.show = true;
      clearTimeout(this.timeoutRef);
      this.toastDetails = val;
      if(this.toastDetails.duration){
        this.timeoutRef = setTimeout(() => { // duration is there
          this.show = false;
        }, this.toastDetails.duration);
      }
      if(this.toastDetails.sticky){ // for sticky
        clearTimeout(this.timeoutRef);
        this.show = true;
      }
      if(!this.toastDetails.duration && !this.toastDetails.sticky){ //no duration and sticky is true
        this.timeoutRef = setTimeout(() => {
          this.show = false;
        }, 5000);
      }
    });
  }
  closeToast() {
    clearTimeout(this.timeoutRef);
    this.show = false;
  }
  loadPosition(){
    let postionClass = "";
    if(this.toastDetails?.position!==undefined){
      switch(this.toastDetails.position){
        case "tr":postionClass= 'toast-right-top';
        break;
        case "tl":postionClass= 'toast-left-top';
        break;
        case "br":postionClass= 'toast-right-bottom';
        break;
        case "bl":postionClass= 'toast-left-bottom';
        break;
        default: postionClass="toast-right-top";
      }
    }else{
      postionClass="toast-right-top"
    }
    if(this.toastDetails?.type!==undefined){
      switch(this.toastDetails.type){
        case "success":postionClass= postionClass + " success";
        break;
        case "error":postionClass= postionClass + " error";
        break;
        case "info":postionClass= postionClass + " info";
        break;
        case "warning":postionClass= postionClass + " warning";
        break;
        default: postionClass="toast-right-top";
      }
    }
    return postionClass;
  }

}
